import { IStatusPanelComp, IStatusPanelParams } from '@ag-grid-community/core'
import {
  ChangeDetectorRef,
  ComponentFactoryResolver,
  ComponentRef,
  Injector,
} from '@angular/core'
import { OmegaTimestampStatusComponent } from './omega-timestamp-status.component'
import { AccountListService } from '../../services/account-list.service'
import { UserPreferencesService } from '@helios/user-preferences'
import { Store } from '@ngrx/store'
import { ConfigureBellModalService } from './configure-bell-modal/configure-bell-modal.service'

export class OmegaTimestampStatusBar implements IStatusPanelComp {
  private componentRef!: ComponentRef<OmegaTimestampStatusComponent>

  init(params: IStatusPanelParams): void {
    const resolver = params.context.resolver as ComponentFactoryResolver

    const injector = Injector.create({
      providers: [
        {
          provide: AccountListService,
          useValue: params.context.accountListService,
        },
        {
          provide: UserPreferencesService,
          useValue: params.context.userPreferencesService,
        },
        {
          provide: Store,
          useValue: params.context.store,
        },
        {
          provide: ConfigureBellModalService,
          useValue: params.context.configureBellModalService,
        },
        {
          provide: 'AccountSetValuesGetter',
          useValue: params.context.getAccountSetValues,
        },
        {
          provide: 'BellFilterSetter',
          useValue: params.context.setBellFilters,
        },
        {
          provide: ChangeDetectorRef,
          useValue: params.context.changeDetector,
        },
      ],
    })

    this.componentRef = resolver
      .resolveComponentFactory(OmegaTimestampStatusComponent)
      .create(injector)

    this.componentRef.instance.init()
  }

  destroy() {
    this.componentRef.instance.destroy()
  }

  getGui(): HTMLElement {
    return this.componentRef.location.nativeElement
  }
}
